function fillCf7SecurityFields(form) {
  if (!form) return;

  const token = form.querySelector('input[name="form_token"]');
  const loaded = form.querySelector('input[name="form_loaded_at"]');

  if (token) {
    token.value = `ok_${Math.random().toString(36).slice(2)}_${Date.now()}`;
  }

  if (loaded) {
    loaded.value = Math.floor(Date.now() / 1000).toString();
  }
}

function initCf7SecurityFields() {
  document.querySelectorAll('.wpcf7-form').forEach(fillCf7SecurityFields);
}

document.addEventListener('DOMContentLoaded', initCf7SecurityFields);

document.addEventListener('wpcf7init', (event) => {
  fillCf7SecurityFields(event.target);
});